import debounce from "../helpers/debounce";

class HeaderHeight {
    constructor() {
        let self = this;

        self.header = document.querySelector('[data-header]');
    }

    init() {
        let self = this;

        // On page load
        window.addEventListener('load', evt => {
            self.setProperty();
        }, false);

        // On window resize
        let debouncedFunction = debounce(function () {
            // Wait half a second for CSS transitions to finish (yeah, bit gross 🤷‍♂️)
            setTimeout(() => {
                self.setProperty();
            }, 500);
        });

        window.addEventListener('resize', function () {
            debouncedFunction();
        }, false);
    }

    setProperty() {
        let self = this;

        if (self.header.offsetHeight > 0) {
            document.documentElement.style.setProperty("--header-height", self.header.offsetHeight + 'px'); 
        } else {
            document.documentElement.style.setProperty("--header-height", '150px');
        }
        
    }
}

export default HeaderHeight;
